import { DEFAULT_RADIUS_FILTER_VALUE, RadiusFilterState } from './radius.types';

export const getDefaultRadiusFilter = (): RadiusFilterState => ({
  currentRadius: DEFAULT_RADIUS_FILTER_VALUE,
});
export const defaultRadiusFilter = getDefaultRadiusFilter();
